import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <Container fluid className="footer">
      <Row className="align-items-center">
        <Col md={4} className="footer-copywright">
          <h3>Designed &amp; Built by Muniraj M</h3>
        </Col>

        <Col md={4} className="footer-copywright">
          <h3>Copyright &copy; {year} MR</h3>
        </Col>

        <Col md={4} className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/Muniraj132"
                className="footer-social-icon"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://x.com/Muniraj2509"
                className="footer-social-icon"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
              >
                <span style={{ fontWeight: "bold", fontSize: "0.9em" }}>𝕏</span>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/muniraj0925/"
                className="footer-social-icon"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/mr.unique.souls/"
                className="footer-social-icon"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
